export let hres63uColumns = () => {
  let indexColumns = [
    {
      key: 'codempid',
      name: '',
      labelCodapp: 'HRES63UC1',
      labelIndex: '30',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'desc_codempid',
      name: '',
      labelCodapp: 'HRES63UC1',
      labelIndex: '40',
      style: 'min-width: 200px;'
    }, {
      key: 'dtereq',
      name: '',
      labelCodapp: 'HRES63UC1',
      labelIndex: '70',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }, {
      key: 'desc_codleave',
      name: '',
      labelCodapp: 'HRES63UC1',
      labelIndex: '90',
      style: 'min-width: 150px;'
    }, {
      key: 'dteperiod',
      name: '',
      labelCodapp: 'HRES63UC1',
      labelIndex: '100',
      class: 'align-center',
      style: 'min-width: 500px;',
      dataType: 'dateRange'
    }, {
      key: 'deslereq',
      name: '',
      labelCodapp: 'HRES63UC3',
      labelIndex: '30',
      style: 'min-width: 200px;'
    }, {
      key: 'status',
      name: '',
      labelCodapp: 'HRES63UC1',
      labelIndex: '110',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codappr',
      name: '',
      labelCodapp: 'HRES63UC1',
      labelIndex: '120',
      style: 'min-width: 200px;'
    }, {
      key: 'dteappr',
      name: '',
      labelCodapp: 'HRES63UC1',
      labelIndex: '130',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }, {
      key: 'remark',
      name: '',
      labelCodapp: 'HRES63UC1',
      labelIndex: '140',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codempap',
      name: '',
      labelCodapp: 'HRES63UC1',
      labelIndex: '150',
      style: 'min-width: 200px;'
    }
  ]

  let tab3TableColumns = [
    {
      key: 'dtework',
      name: '',
      labelCodapp: 'HRES63UC5',
      labelIndex: '50',
      class: 'align-center',
      style: 'min-width: 120px;',
      dataType: 'date'
    }, {
      key: 'codshift',
      name: '',
      labelCodapp: 'HRES63UC5',
      labelIndex: '60',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'timperiod',
      name: '',
      labelCodapp: 'HRES63UC5',
      labelIndex: '70',
      class: 'align-center',
      style: 'min-width: 200px;'
    }, {
      key: 'codleave',
      name: '',
      labelCodapp: 'HRES63UC5',
      labelIndex: '80',
      class: 'align-center',
      style: 'min-width: 150px;'
    }, {
      key: 'desc_codleave',
      name: '',
      labelCodapp: 'HRES63UC5',
      labelIndex: '90',
      style: 'min-width: 200px;'
    }, {
      key: 'qtymin',
      name: '',
      labelCodapp: 'HRES63UC5',
      labelIndex: '100+110',
      class: 'align-center',
      style: 'min-width: 150px;'
    }, {
      key: 'numlereq',
      name: '',
      labelCodapp: 'HRES63UC5',
      labelIndex: '120',
      class: 'align-center',
      style: 'min-width: 150px;'
    }
  ]

  return {
    en: {
      index: indexColumns,
      detailTab3: tab3TableColumns
    },
    th: {
      index: indexColumns,
      detailTab3: tab3TableColumns
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/columns/hres63u.js